The date & time the job ad was closed. This corresponds to the `Event.createDateTime` field in the GraphQL schema.
